import _ from 'lodash';
import Immutable from 'immutable';

function getSceneRecordsKey(scene) {
  if (scene.has('calendarRecords')) return 'calendarRecords';
  if (scene.has('cardsRecords')) return 'cardsRecords';
  if (scene.has('reportsRecords')) return 'reportsRecords';
  if (scene.has('pivotRecords')) return 'pivotRecords';
  return 'records';
}

export default {
  setUrlItems(items) {
    const urlItems = this.get('calendar') ? this.get('calendar').toJS() : {};
    const newUrlItems = _.merge(urlItems, items);
    this.set('calendar', Immutable.fromJS(newUrlItems));
    this.changed();
  },

  moveRecordFromTo(fromSceneId, toSceneId, record) {
    const fromScene = this.getIn(['scenes', fromSceneId]);
    const toScene = this.getIn(['scenes', toSceneId]);

    if (!fromScene || !toScene) {
      return console.warn(
        'Error while dragging record to calendar',
        !fromScene ? 'fromScene' : 'toScene',
        ' are Empty',
      );
    }

    if (!record) {
      return console.warn('Error while dragging record to calendar. Event is empty');
    }

    const fromKey = getSceneRecordsKey(fromScene);
    const toKey = getSceneRecordsKey(toScene);
    const sourceRecords = fromScene.get(fromKey);
    const targetRecords = toScene.get(toKey) || Immutable.Map();

    if (!sourceRecords) return;

    const sourceRecord = sourceRecords.find((r) => r.get('id') == record.get('id'));

    /* конец работы с источником данных */

    /* работа с таргетом данных */
    if (!sourceRecord) return;

    const targetRecordKey = String(targetRecords.size);
    this.setIn(['scenes', toSceneId, toKey, targetRecordKey], sourceRecord);

    this.changed();
  },

  deleteRecordFromScene(sceneId, recordId) {
    const scene = this.getIn(['scenes', sceneId]);
    if (!scene) return;

    const recordsKey = getSceneRecordsKey(scene);
    const records = scene.get(recordsKey);
    if (!records) return;

    const recordKey = records.findKey((r) => r.get('id') == recordId);
    if (recordKey === undefined || recordKey < 0) return;

    this.deleteIn(['scenes', sceneId, recordsKey, recordKey]);
    this.changed();
  },

  // eslint-disable-next-line default-param-last
  updateRecordBeforeMakeRequest(params = {}, values, sceneId) {
    const scene = this.getIn(['scenes', sceneId]);
    if (!scene || !params.recordId) return;

    const recordsKey = getSceneRecordsKey(scene);
    const records = scene.get(recordsKey);
    if (!records) return;

    const recordKey = records.findKey((r) => r.get('id') === params.recordId);
    if (recordKey === undefined || recordKey < 0) return;

    let record = records.get(recordKey);
    values = _.isUndefined(values) ? record.get('originValues') : Immutable.fromJS(values);
    record = record.mergeIn(['values'], values);

    this.setIn(['scenes', sceneId, recordsKey, recordKey], record);
  },
};
